"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconBasedOnValidationState = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
var _spinner = require("../../spinner");
// TODO once ursa-icons is available, use that instead!
const IconWrapper = (0, _styled.default)("div")`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const ursaIcon = /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("mask", {
  id: "path-1-inside-1_2564_10060",
  fill: "white"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.00005 1.34999C3.43192 1.34999 1.35005 3.43186 1.35005 5.99999C1.35005 8.56811 3.43192 10.65 6.00005 10.65C8.56817 10.65 10.65 8.56811 10.65 5.99999C10.65 3.43186 8.56817 1.34999 6.00005 1.34999ZM0.0500488 5.99999C0.0500488 2.71389 2.71395 0.0499878 6.00005 0.0499878C9.28614 0.0499878 11.95 2.71389 11.95 5.99999C11.95 9.28608 9.28614 11.95 6.00005 11.95C2.71395 11.95 0.0500488 9.28608 0.0500488 5.99999Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.00004 6.94999C5.64105 6.94999 5.35004 6.65897 5.35004 6.29999V3.59999C5.35004 3.241 5.64105 2.94999 6.00004 2.94999C6.35902 2.94999 6.65004 3.241 6.65004 3.59999V6.29999C6.65004 6.65897 6.35902 6.94999 6.00004 6.94999Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M5.25004 8.49999C5.25004 8.08577 5.58582 7.74999 6.00004 7.74999C6.41425 7.74999 6.75004 8.08577 6.75004 8.49999C6.75004 8.9142 6.41425 9.24999 6.00004 9.24999C5.58582 9.24999 5.25004 8.9142 5.25004 8.49999Z"
})), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.00005 1.34999C3.43192 1.34999 1.35005 3.43186 1.35005 5.99999C1.35005 8.56811 3.43192 10.65 6.00005 10.65C8.56817 10.65 10.65 8.56811 10.65 5.99999C10.65 3.43186 8.56817 1.34999 6.00005 1.34999ZM0.0500488 5.99999C0.0500488 2.71389 2.71395 0.0499878 6.00005 0.0499878C9.28614 0.0499878 11.95 2.71389 11.95 5.99999C11.95 9.28608 9.28614 11.95 6.00005 11.95C2.71395 11.95 0.0500488 9.28608 0.0500488 5.99999Z",
  fill: "currentColor"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.00004 6.94999C5.64105 6.94999 5.35004 6.65897 5.35004 6.29999V3.59999C5.35004 3.241 5.64105 2.94999 6.00004 2.94999C6.35902 2.94999 6.65004 3.241 6.65004 3.59999V6.29999C6.65004 6.65897 6.35902 6.94999 6.00004 6.94999Z",
  fill: "currentColor"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M5.25004 8.49999C5.25004 8.08577 5.58582 7.74999 6.00004 7.74999C6.41425 7.74999 6.75004 8.08577 6.75004 8.49999C6.75004 8.9142 6.41425 9.24999 6.00004 9.24999C5.58582 9.24999 5.25004 8.9142 5.25004 8.49999Z",
  fill: "currentColor"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M5.35004 6.29999H6.35004H5.35004ZM5.35004 3.59999H4.35004H5.35004ZM6.65004 3.59999H5.65004H6.65004ZM6.65004 6.29999H7.65004H6.65004ZM5.25004 8.49999H4.25004H5.25004ZM6.00004 7.74999V8.74999V7.74999ZM6.75004 8.49999H5.75004H6.75004ZM6.00004 9.24999V10.25V9.24999ZM2.35005 5.99999C2.35005 3.98415 3.98421 2.34999 6.00005 2.34999V0.349988C2.87964 0.349988 0.350049 2.87958 0.350049 5.99999H2.35005ZM6.00005 9.64999C3.98421 9.64999 2.35005 8.01583 2.35005 5.99999H0.350049C0.350049 9.1204 2.87964 11.65 6.00005 11.65V9.64999ZM9.65005 5.99999C9.65005 8.01583 8.01589 9.64999 6.00005 9.64999V11.65C9.12046 11.65 11.65 9.1204 11.65 5.99999H9.65005ZM6.00005 2.34999C8.01589 2.34999 9.65005 3.98415 9.65005 5.99999H11.65C11.65 2.87958 9.12046 0.349988 6.00005 0.349988V2.34999ZM6.00005 -0.950012C2.16167 -0.950012 -0.949951 2.16161 -0.949951 5.99999H1.05005C1.05005 3.26618 3.26624 1.04999 6.00005 1.04999V-0.950012ZM12.95 5.99999C12.95 2.16161 9.83843 -0.950012 6.00005 -0.950012V1.04999C8.73386 1.04999 10.95 3.26618 10.95 5.99999H12.95ZM6.00005 12.95C9.83843 12.95 12.95 9.83837 12.95 5.99999H10.95C10.95 8.7338 8.73386 10.95 6.00005 10.95V12.95ZM-0.949951 5.99999C-0.949951 9.83837 2.16167 12.95 6.00005 12.95V10.95C3.26624 10.95 1.05005 8.7338 1.05005 5.99999H-0.949951ZM4.35004 6.29999C4.35004 7.21126 5.08877 7.94999 6.00004 7.94999V5.94999C6.19334 5.94999 6.35004 6.10669 6.35004 6.29999H4.35004ZM4.35004 3.59999V6.29999H6.35004V3.59999H4.35004ZM6.00004 1.94999C5.08877 1.94999 4.35004 2.68872 4.35004 3.59999H6.35004C6.35004 3.79329 6.19334 3.94999 6.00004 3.94999V1.94999ZM7.65004 3.59999C7.65004 2.68872 6.91131 1.94999 6.00004 1.94999V3.94999C5.80674 3.94999 5.65004 3.79329 5.65004 3.59999H7.65004ZM7.65004 6.29999V3.59999H5.65004V6.29999H7.65004ZM6.00004 7.94999C6.91131 7.94999 7.65004 7.21126 7.65004 6.29999H5.65004C5.65004 6.10669 5.80674 5.94999 6.00004 5.94999V7.94999ZM6.25004 8.49999C6.25004 8.63806 6.13811 8.74999 6.00004 8.74999V6.74999C5.03354 6.74999 4.25004 7.53349 4.25004 8.49999H6.25004ZM6.00004 8.74999C5.86197 8.74999 5.75004 8.63806 5.75004 8.49999H7.75004C7.75004 7.53349 6.96654 6.74999 6.00004 6.74999V8.74999ZM5.75004 8.49999C5.75004 8.36192 5.86197 8.24999 6.00004 8.24999V10.25C6.96654 10.25 7.75004 9.46649 7.75004 8.49999H5.75004ZM6.00004 8.24999C6.13811 8.24999 6.25004 8.36192 6.25004 8.49999H4.25004C4.25004 9.46649 5.03354 10.25 6.00004 10.25V8.24999Z",
  fill: "currentColor",
  mask: "url(#path-1-inside-1_2564_10060)"
})));
const icons = {
  error: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.AlertErrorAltIcon, {
      size: "small",
      role: "img",
      color: (0, _designTokensReact.color)("color--icons--error--weak")
    }),
    "ursa-light": ursaIcon
  },
  warn: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.AlertWarningIcon, {
      size: "small",
      role: "img",
      color: (0, _designTokensReact.color)("color--icons--warning--weak")
    }),
    "ursa-light": ursaIcon
  },
  info: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.InfoIcon, {
      size: "small",
      role: "img"
    }),
    "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.InfoIcon, {
      size: 16,
      color: (0, _designTokensReact.color)("color--text--neutral--weak")
    })
  },
  success: {
    "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.CheckIcon, {
      size: "small",
      role: "img",
      color: (0, _designTokensReact.color)("color--icons--success--weak")
    }),
    "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.CheckInCircleIcon, {
      size: 16,
      color: (0, _designTokensReact.color)("color--icons--success--default")
    })
  }
};
const iconBasedOnValidationState = (validationState, themeMode) => {
  if (validationState === "waiting") return /*#__PURE__*/_react.default.createElement(_spinner.Spinner, null);
  switch (themeMode) {
    // Lodestar and oldestar use the same Lodestar icon on purpose here. Oldestar never had a
    // FormLabel component so it was alright to use the new icons.
    case "oldestar":
    case "lodestar-light":
      return icons[validationState]["lodestar-light"];
    case "ursa-light":
    case "ursa-dark":
      return icons[validationState]["ursa-light"];
  }
};
exports.iconBasedOnValidationState = iconBasedOnValidationState;
//# sourceMappingURL=formLabelIcons.js.map